export default __webpack_public_path__ + "static/media/Recipes-Details.0811b39c.png";